import { syncMixpanelConsent } from '@/services/mixpanelConsent';

export const gtmPlugin = (store) => {
  if (typeof window === 'undefined') return; // SSR guard if needed

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }

  // When the app boots, update consent from your stored state
  // (HTML already set a very strict 'denied' default)
  const currentConsent = store.getters['consent/consentData'];
  gtag('consent', 'update', currentConsent);

  // Listen for consent changes
  store.subscribe((mutation) => {
    if (mutation.type === 'consent/setHasConsent' || mutation.type === 'consent/setConsentData') {
      const consent = store.getters['consent/consentData'];
      gtag('consent', 'update', consent);

      // Basic consent mode: the GTM container is held back too (see
      // public/index.html), so granting has to load it, not just flip the
      // state. The update above has to reach the dataLayer first, or the first
      // tags evaluate against the denied default. loadGtm is idempotent.
      if (consent.analytics_storage === 'granted' && typeof window.loadGtm === 'function') {
        window.loadGtm();
      }

      // Mixpanel is initialised opted out, so the choice has to be handed to
      // it as well - including a change of mind, which opts it back out.
      syncMixpanelConsent();

      // tolt.js is held back until consent is given (see public/index.html), so
      // load it here rather than leaving it until the next page load.
      if (consent.ad_storage === 'granted' && typeof window.loadToltScript === 'function') {
        window.loadToltScript();
      }
    }
  });
};
